module.exports = __webpack_public_path__ + "img/lanzhou.a9188d04.jpg";